module.exports = __webpack_public_path__ + "static/media/dcs001.5af16f1c.png";